
    import {IPage} from "@/js/page";
    import {Component, Vue, Watch} from "vue-property-decorator";
    import {rulesApi} from "@/api/rules";
    import SetTableColumns from "@/components/SetTableColumns.vue"
    import baseUrl from "@/constants";

    @Component({
        name: "rulesList",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        mode = ''; // Country：国家 Local：地方 Other：其他
        modeValue = "ALL";//ALL 所有,Examine 审核,Share 共享
        modeType = "WaitShare";  //WaitShare 待共享 Share 已共享
        showForm = false;
        private exportExcel: any;
        dataList = [];
        listParam: IPage = {
            size: 50,
            current: 1,
        };
        downloadRuleEnclosure = false; // 下载附件权限
        rulesEdit = false; //修改权限
        rulesExamine = false; //审核权限
        rulesShare = false;//共享权限
        propParams = this.getPropParams();
        listTotal = 0;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        tabCol = [];
        allSelected = [];
        loading = false;
        share = {
            shareCount: 0,
            waitShareCount: 0,
        }
        created() {
            this.haveRight();
            this.init();
        }
        getHeaderTitle(){
            let title = "";
            if(this.mode === 'Country'){
                title = '国家规程规范'
            }else if(this.mode === 'Local'){
                title = '地方规程规范'
            }else if(this.mode === 'Other'){
                title = '其他规程规范'
            }
            return title;
        }
        getCount(mode: string, e: any){
            let count = 0;
            try{
                if(mode === 'draftUnitNum'){
                    count = e.draftUnit&&JSON.parse(e.draftUnit)[0].name ? JSON.parse(e.draftUnit).length : 0;
                    count += (e.draftUnitPart&&JSON.parse(e.draftUnitPart)[0].name ? JSON.parse(e.draftUnitPart).length : 0);
                }else if(mode === 'drafterNum'){
                    count = e.drafter&&JSON.parse(e.drafter)[0].name ? JSON.parse(e.drafter).length : 0;
                    count += (e.drafterPart&&JSON.parse(e.drafterPart)[0].name ? JSON.parse(e.drafterPart).length : 0);
                }
            }catch (e) {
                console.log(e);
            }
            return count
        }
        changeModelType(){
            this.refresh();
        }
        getPropParams() {
            return {
                name: '',
                number: '',
                status: '',
                auditStatus: '',
                releaseOffice: '',
                releaseTime: '',
                releaseEndTime: '',
                implementTime: '',
                implementEndTime: '',
                implementRegion: '',
                currentStatus: '',
                replaceRules: '',
                beReplaceRules: '',
                draftUnitNum: '',
                drafterNum: '',
            }
        }
        activated() {
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            } else {
                this.init();
            }
            this.tableClearSelect();
        }
        haveRight(){
            const right = this.$store.state.userRights;
            right.forEach((e:any)=>{
                if(e.name == "rules_edit" || e.name == "country_rules_edit" || e.name == "other_rules_edit"){ //地方规程编辑 国家规程编辑 其它规程编辑
                    this.rulesEdit = true;
                }
                if(e.name == "rule_examine" || e.name == "country_rules_examine" || e.name == "other_rules_examine"){
                    this.rulesExamine = true;
                }
                if(e.name == "rules_share"){
                    this.rulesShare = true;
                }
                if(e.name == "download_rule_enclosure"){
                    this.downloadRuleEnclosure = true;
                }
            })
        }
        init(){
            const route = this.$route;
            const q = JSON.parse(JSON.stringify(route.query));
            if (q.size) {
                this.listParam.size = Number(q.size);
                this.listParam.current = Number(q.current);
            }
            this.mode = this.$route.params.mode
            this.modeValue = this.$route.params.modeValue;
            if(this.modeValue === 'Share'){
                this.countShareRules();
            }
            this.loadData(null);
        }
        down(row: any) {
            try {
                var obj=JSON.parse(row);
                if(typeof obj == 'object' && obj ){
                    if(this.downloadRuleEnclosure){
                        window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    }else{
                        const router = this.$router.resolve({path: '/pdfviewer', query: {'pdfurl': encodeURI(obj[0].url)}});
                        window.open(router.href,'_blank');
                    }
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=" + this.getHeaderTitle() + "影印件", '_blank');
                return false;
            }
        }
        countShareRules(){
            rulesApi.countShareRules(this.mode).then((r: any) => {
                if(r.data.result === 0){
                    this.share = r.data.data;
                }
            });
        }
        loadData(callback: any){
            this.loading = true;
            this.tableClearSelect();
            const route = this.$route;
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q, this.listParam);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            const params = {
                mode: this.mode,
                modeValue: this.modeValue,
                modeType: this.modeType,
                ...this.listParam,
                ...this.propParams,
            } as any;
            let API = rulesApi.pageV3(params);
            API.then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.dataList = rData;
                    this.loading = false;
                    if (callback) {
                        callback();
                    }
                    this.$nextTick(() => {
                        let $table = this.$refs.table as HTMLFormElement;
                        if ($table) {
                            $table.doLayout();
                        }
                    })
                }
            });
        }

        toDetail(type: string) {
            const dataArr = this.allSelected as any;
            let id = 0;
            if (type != 'Add') {
                if (dataArr.length == 0) {
                    this.$message.error("请先勾选");
                    return;
                }
                if (type === 'Release' || type == "Recall") {
                    this.batchReleaseOrRecall(dataArr, type);
                    return;
                }

                if (type == 'Del') {
                    const data = dataArr.filter((d: any) => d.auditStatus.value === 2);
                    if (data.length > 0) {
                        const names = data.flatMap((e: any) => e.name).join(",");
                        this.$message.error("您选择的 【" + names + "】已通过，无法进行删除！");
                        return;
                    }
                    this.batchDelete(dataArr);
                    return;
                }

                if (dataArr.length > 1 && (type == 'Look' || type == 'Edit' || type == 'Examine')) {
                    this.$message.error("只能勾选一条");
                    return;
                }

                if (type == 'Submit') {
                    const data = dataArr.filter((d: any) => d.auditStatus.value === 2);
                    if (data.length > 0) {
                        const names = data.flatMap((e: any) => e.name).join(",");
                        this.$message.error("您选择的 【" + names + "】已通过，无法进行提交！");
                        return;
                    }
                }
                if (type == 'Submit') {
                    this.batchSubmit(dataArr);
                    return;
                }
                if (type == 'Edit') {
                    this.toEdit(dataArr[0], type);
                    return;
                }
                id = dataArr[0].id;
            }
            this.goDetail(type, id);
        }

        goDetail(type: string, id: number) {
            const firstRouterText = this.$route.path.split("/")[1];
            let rulesType = 0, pageType = 0;
            if (this.mode === 'Country') {
                rulesType = 1;
            } else if (this.mode === 'Local') {
                rulesType = 0;
            }else if(this.mode === 'Other'){
                rulesType = 3;
            }
            if (type === 'Add') {
                pageType = 0;
            } else if (type === 'Look') {
                pageType = 2;
            } else if (type === 'Examine') {
                pageType = 4;
            } else if (type === 'Edit') {
                pageType = 1;
            }
            this.$router.push("/" + firstRouterText + "/Detail/" + id + "/" + pageType + "/" + rulesType);
        }

        toEdit(data: any, type: string) {
            if (data.auditStatus.value === 2) {
                this.$confirm('您勾选的是审核“已通过”的规程规范，编辑并保存后需要重新提交审核，是否继续编辑？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    this.goDetail(type, data.id);
                });
            } else {
                this.goDetail(type, data.id);
            }
        }

        batchDelete(dataArr: any) {
            this.$confirm('您勾选了:  ' + dataArr.length + '条规程规范，是否删除', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                rulesApi.delete(dataArr.flatMap((e: any) => e.id).join(",")).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.loadData(null);
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

      batchReleaseOrRecall(dataArr: any, type: string) {
        const str = type == 'Release' ? '发布' : '撤回';
        this.$confirm('您勾选了:  ' + dataArr.length + '条规程规范，是否' + (str) + '？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          const loading = this.$loading({
            text: `正在${str}，请等待...`,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          rulesApi.updateReleaseStatus(dataArr.flatMap((e: any) => e.id).join(","), (type === 'Release' ? 1 : 2)).then(r => {
            loading.close();
            if (r.data.result === 0) {
              this.$message.success((str) + "成功！");
              this.loadData(null);
              if (this.modeValue === 'Share') {
                this.countShareRules();
              }
            }
          })
        })
      }

        batchSubmit(dataArr: any) {
            this.$confirm('您勾选了' + dataArr.length + '条规程规范，是否提交审核？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                rulesApi.examine(dataArr.flatMap((e: any) => e.id).join(","), 1, "").then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("提交成功");
                        this.refresh();
                    }
                })
            })
        }

        onExportExcel() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const listParam = JSON.parse(JSON.stringify(this.listParam));
            this.listParam.size = this.listTotal;    //将表格长度变成数据总长度
            this.listParam.current = 1;          //显示第一页
            this.loadData(() => {
                this.exportExcel(() => {
                    this.listParam = listParam;    //表格长度还原
                    this.loadData(null);
                    loading.close();
                }, this.getHeaderTitle() + ".xlsx");
            });
        }

        hasBtn(mode: string) {
            if (mode === 'Add') {
                return this.modeValue === 'ALL' && this.rulesEdit;
            } else if (mode === 'Excel' || mode === 'Look') {
                return this.modeValue === 'ALL';
            } else if (mode === 'Release') {
                return this.modeValue === 'Share' && this.modeType === 'WaitShare' && this.rulesShare;
            } else if (mode === 'Recall') {
                return this.modeValue === 'Share' && this.modeType === 'Share' && this.rulesShare;
            } else if (mode === 'Examine') {
                return this.modeValue === 'Examine' && this.rulesExamine;
            } else if (mode === 'Edit') {
                return this.modeValue === 'ALL' && this.rulesEdit;
            } else if (mode === 'Submit') {
                return this.modeValue === 'ALL' && this.rulesEdit;
            } else if (mode === 'Del') {
                return this.modeValue === 'ALL' && this.rulesEdit;
            }
            return false;
        }

        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }
        reset(){
            this.propParams = this.getPropParams();
            this.refresh();
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
            })
        }
        handleClick() {
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
            this.refresh();
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.loadData(null);
        }
        indexMethod(index: any) {
            return (this.listParam.current - 1) * this.listParam.size + index + 1;
        }
        refresh() {
            this.listParam.current = 1;
            this.loadData(null);
        }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }

        checkboxInit(row: any, index: number) {
            if (row.result) {
                return 0;//0不可勾选
            } else {
                return 1;//1可勾选
            }
        }

      querySearch(queryString: string, cb: any){
        let options = [{value: "全国"}, {value: "河北省"}, {value: "京津冀"}, {value: "华北大区"}, {value: "其他"}];
        if(queryString){
          options = options.filter(option => option.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
        cb(options);
      }
    }
